import { getToken } from 'modules/auth/services'
import { API_URL } from '../constants'

interface Options extends RequestInit {
  mode: 'cors'
  credentials: 'same-origin'
  headers: Headers
}

export const callApi = <T = any>(
  path: string,
  method: string = 'GET',
  data: unknown | null = null,
  overrideToken?: string,
  urlSearchParams?: URLSearchParams,
  domain?: string
): Promise<T> => {
  const url = new URL([domain ? domain : API_URL, path].join(''))

  if (urlSearchParams) url.search = urlSearchParams.toString()

  const options: Options = {
    method,
    mode: 'cors',
    credentials: 'same-origin',
    headers: new Headers()
  }

  if (data) {
    options.headers.set('Content-Type', 'application/json')
    options.body = JSON.stringify(data)
  }

  const token = overrideToken || getToken()

  if (token) {
    options.headers.set('Authorization', `Bearer ${token}`)
  }

  return fetch(url.toString(), options).then(async response => {
    const json = await response.json()

    if (!response.ok) throw json

    return json
  })
}
